<div class="modal-body">
  <form [formGroup]="form">
    <app-consent-proctoring-page
      [showBreadcrumb]="showBreadcrumb"
    ></app-consent-proctoring-page>

    <div class="container-content">
      <app-form-field-checkbox
        [label]="
          'consent-form-proctoring.sdv.checkbox-label'
        "
        [field]="consentControl"
      ></app-form-field-checkbox>

      <p>
        {{
          'consent-form-proctoring.sdv.paragraph-7'
            | translate
        }}
      </p>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    class="btn btn-primary"
    [disabled]="!form.valid"
    (click)="nextAndClose()"
  >
    {{ 'button.next' | translate }}
  </button>
</div>
